function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
document.addEventListener('DOMContentLoaded', function () {
  var validFileTypes = ['image/jpeg', 'image/png'];
  var uploadUrl = 'https://maloka-web-service-001.onrender.com/upload';
  document.body.addEventListener('change', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
      var input, container, label, key, preview, removeButton, file, uuid, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (event.target.classList.contains('image-input')) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            input = event.target;
            container = input.closest('.image-upload-container');
            label = container.querySelector('.selector-var');
            key = container.dataset.key;
            preview = container.querySelector('.image-preview');
            removeButton = container.querySelector('.remove-button');
            file = input.files[0];
            if (!(!file || !validFileTypes.includes(file.type))) {
              _context.n = 2;
              break;
            }
            alert('Please select a valid image file (JPEG/PNG).');
            return _context.a(2);
          case 2:
            preview.classList.remove('hidden');
            label.textContent = 'Uploading...';
            _context.p = 3;
            _context.n = 4;
            return uploadImage(file, key);
          case 4:
            uuid = _context.v;
            input.dataset.uuid = uuid;
            label.textContent = 'Image uploaded';
            label.classList.add('uploaded');
            _context.n = 6;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            console.error('Upload error:', _t);
            preview.classList.add('hidden');
            label.textContent = 'Add a reference image';
            label.classList.remove('uploaded');
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[3, 5]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  document.body.addEventListener('click', function (event) {
    if (!event.target.classList.contains('remove-button')) return;
    var button = event.target;
    var container = button.closest('.image-upload-container');
    var preview = container.querySelector('.image-preview');
    var input = container.querySelector('.image-input');
    var label = container.querySelector('.selector-var');
    input.value = '';
    delete input.dataset.uuid;
    preview.dataset.uuid = '';
    preview.classList.add('hidden');
    label.textContent = 'Add a reference image';
    label.classList.remove('uploaded');
  });
  function uploadImage(_x2, _x3) {
    return _uploadImage.apply(this, arguments);
  }
  function _uploadImage() {
    _uploadImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(file, key) {
      var formData, response, data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            formData = new FormData();
            formData.append('file', file);
            _context2.n = 1;
            return fetch(uploadUrl, {
              method: 'POST',
              body: formData
            });
          case 1:
            response = _context2.v;
            if (response.ok) {
              _context2.n = 2;
              break;
            }
            throw new Error('Upload failed');
          case 2:
            _context2.n = 3;
            return response.json();
          case 3:
            data = _context2.v;
            return _context2.a(2, data.uuid);
        }
      }, _callee2);
    }));
    return _uploadImage.apply(this, arguments);
  }
});